import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  iEmpStationsRequest,
  iEmpStationsResult,
} from 'src/app/helpers/Interfaces/emp-stations';
import {
  iPaginationRequest,
  iPaginationResult,
} from 'src/app/helpers/Interfaces/pagination';

import {
  iStationRequest,
  iStationResult,
} from 'src/app/helpers/Interfaces/station';
import { environment } from 'src/environments/environment.development';

@Injectable({
  providedIn: 'root',
})
export class StationService {
  private readonly _empStations = `${environment.base_url}/api/EmpStations`;

  // Stations
  private readonly _getAll = `${environment.base_url}/api/Station/GetAll`;
  private readonly _getAllWithRelationShip = `${environment.base_url}/api/Station/GetAllWithRelationShip`;
  private readonly _getAllPaginated = `${environment.base_url}/api/Station/GetAllNew`;
  private readonly _add = `${environment.base_url}/api/Station/Add`;
  private readonly _update = `${environment.base_url}/api/Station/Update`;
  private readonly _remove = `${environment.base_url}/api/Station/Remove`;

  // Emp Stations
  private readonly _getEmpStations = `${this._empStations}/GetByEmployeeId`;
  private readonly _addRangeEmpStations = `${this._empStations}/AddRange`;
  private readonly _deleteRangeEmpStations = `${this._empStations}/RemoveRange`;

  constructor(private _http: HttpClient) { }

  // Stations
  getAll(companyId?: string, alt = false) {
    let headers = new HttpHeaders();
    if (companyId) headers = headers.set('CompanyId', companyId);
    if (alt) headers = headers.set('CompanyId', environment.emptyGuid);
    return this._http.get<iStationResult[]>(this._getAll, {
      responseType: 'json',
      headers,
    });
  }
  add(payload: iStationRequest) {
    return this._http.post<iStationResult>(this._add, payload, {
      responseType: 'json',
    });
  }
  update(payload: iStationRequest) {
    return this._http.put<iStationResult>(this._update, payload, {
      responseType: 'json',
    });
  }
  remove(id: string) {
    return this._http.delete(`${this._remove}?id=${id}`, {
      responseType: 'json',
    });
  }

  // Emp Stations
  getEmpStations(empId: string) {
    return this._http.get<iEmpStationsResult[]>(
      `${this._getEmpStations}?id=${empId}`,
      {
        responseType: 'json',
      }
    );
  }
  addRangeEmpStations(payload: iEmpStationsRequest[]) {
    return this._http.post(this._addRangeEmpStations, payload, {
      responseType: 'json',
    });
  }
  removeRangeEmpStations(empId: string) {
    return this._http.delete(
      `${this._deleteRangeEmpStations}?EmployeeId=${empId}`,
      {
        responseType: 'json',
      }
    );
  }
  getAllWithRelationShip(payload: iPaginationRequest) {
    return this._http.post<iPaginationResult<iStationResult>>(
      `${this._getAllWithRelationShip}`,
      payload,
      {
        responseType: 'json',
      }
    );
  }
  getAllPaginated(payload: iPaginationRequest) {
    return this._http.post<iPaginationResult<iStationResult>>(
      `${this._getAllPaginated}`,
      payload,
      {
        responseType: 'json',
      }
    );
  }
}
